export default __webpack_public_path__ + "static/media/services_decor.e353af75.jpg";